import { CollectionReference, db, DocumentReference } from "api/firebase";
import Order from "ts/api/order";

export type ShowOrderDocRef = DocumentReference<Order>;
export type ShowOrderCollectionRef = CollectionReference<Order>;

type GetDocumentArgs = {
  showId: string;
  orderId: string;
};

type GetCollectionArgs = Pick<GetDocumentArgs, "showId">;

const orderRefs = {
  getCollection: ({ showId }: GetCollectionArgs) =>
    db
      .collection("shows")
      .doc(showId)
      .collection("orders") as ShowOrderCollectionRef,

  getDocument: ({ showId, orderId }: GetDocumentArgs) =>
    orderRefs.getCollection({ showId }).doc(orderId) as ShowOrderDocRef,
};

export default orderRefs;
